import React, { useEffect, useState } from "react";
import api, { baseURL } from "../api";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import innerBanner from "../../assets/images/banner/inner-banner.jpg";
import pdficon from "../../assets/images/icons/PDF-Icons.png";

const RightToService = () => {
  const { i18n, t } = useTranslation();
  const [pdfData, setPdfData] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Function to convert URLs in text to clickable links
  const formatDescriptionWithLinks = (text) => {
    if (!text) return text;
    
    // Regular expression to match URLs starting with http:// or https://
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    
    // Split the text by URLs and map to React elements
    const parts = text.split(urlRegex);
    
    return parts.map((part, index) => {
      if (part.match(urlRegex)) {
        // It's a URL - create a link
        return (
          <a 
            key={index} 
            href={part} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-primary hover:underline"
          >
            {part}
          </a>
        );
      }
      // It's regular text
      return part;
    });
  };

  useEffect(() => {
    api
      .get(`/rts_table?lang=${i18n.language}`)
      .then((response) => {
        setPdfData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching PDF data:", error);
      });
  }, [i18n.language]);

  useEffect(() => {
    api
      .get(`/righttoservices?lang=${i18n.language}`)
      .then((response) => {
        setServices(response.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("There was an error fetching the data!", err);
        setError("Failed to fetch services. Please try again later.");
        setLoading(false);
      });
  }, [i18n.language]);

  const groupedServices = services.reduce((acc, service) => {
    if (!acc[service.heading]) {
      acc[service.heading] = [];
    }
    acc[service.heading].push(service.description);
    return acc;
  }, {});

  if (loading) return <p>{t("loading")}</p>;
  if (error) return <p>{error}</p>;

  return (
    <>
      <section className="page-title ">
        <div
          className="bg-layer"
          style={{ backgroundImage: `url(${innerBanner})` }}
        ></div>
        <div className="line-box">
          <div className="line-1"></div>
          <div className="line-2"></div>
        </div>
        <div className="auto-container">
          <div className="content-box">
            <h1>{t("rtsContent.rightToService")}</h1>
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/">{t("home")}</Link>
              </li>
              <li>
                <span>{t("rtsContent.rightToService")}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <div id="main-content">
      <br />
      <br />
      <br />
      <section className="service-style-four rts_inner">
        <div className="auto-container">
          <h4 className="mb-3 color_blue">
            {t("rtsContent.headingKulgaon")}
          </h4>
          <div>
            {Object.keys(groupedServices).length === 0 ? (
              <p>{t("rtsContent.noServicesAvailable")}</p>
            ) : (
              Object.entries(groupedServices).map(([heading, descriptions]) => (
                <div key={heading}>
                  <h5 className="mb-3">{heading}</h5>
                  {descriptions.map((description, index) => (
                    <p className="mb-0" key={index}>
                      {formatDescriptionWithLinks(description)}
                    </p>
                  ))}
                </div>
              ))
            )}
          </div>

          <div className="table-responsive mt-3">
            <table className="table table-bordered">
              <thead className="text-center">
                <tr>
                  <th
                    width="10%"
                    style={{ backgroundColor: "#29aae1", color: "#fff" }}
                  >
                    {t("srNo")}
                  </th>
                  <th
                    className="text-center"
                    style={{ backgroundColor: "#29aae1", color: "#fff" }}
                  >
                    {t("description")}
                  </th>
                  <th
                    width="15%"
                    style={{ backgroundColor: "#29aae1", color: "#fff" }}
                  >
                    {t("rtsContent.downloadPDF")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {pdfData.map((item, index) => (
                  <tr key={item.id}>
                    <td className="text-center">{index + 1}</td>
                    <td className="text-center">
                      {formatDescriptionWithLinks(item.description)}
                    </td>
                    <td className="text-center">
                      <div className="download-box">
                        <div className="icon-box">
                          <Link
                            to={`${baseURL}/${item.pdf_path}`}
                            target="_blank"
                          >
                            <img width="25px" src={pdficon} alt="pdf_icon" />
                          </Link>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
      </div>
    </>
  );
};

export default RightToService;